import Promise from 'promise-polyfill';
import appConfig from '../config/app';

//@deprecated
// Добавляем полифил промисов
if (!window.Promise) {
	window.Promise = Promise;
}

const apiRoot = appConfig.apiUrl;
const newApiRoot = appConfig.newApiUrl;

// Имплементация класса взаимодействия по REST API
class API {
	get = (url, body) => {
		return this.sendRequest('GET', url, body)
	}

	post = (url, body) => {
		return this.sendRequest('POST', url, body)
	}

	put = (url) => {
		return this.sendRequest('PUT', url)
	}

	delete = (url) => {
		return this.sendRequest('DELETE', url)
	}

	sendRequest = (method, url, body) => {
		const headers = {
			'Accept': 'application/json',
			'Content-Type': 'application/json; charset=UTF-8'
		};

		let auth_to_send = localStorage.getItem('AuthToken') || null;
		if (auth_to_send) {
			headers['Authorization'] = `Bearer ${auth_to_send}`;
		}

		const config = {
			method,
			headers
		};

		if ( method !== 'GET') {
			if (body) {
				config.body = JSON.stringify(body);
			}
		}

		if (method === 'GET') {
			url = this.formURL(body, url);
		}

		const finalUrl = this.joinRootToUrl(url);

		return fetch(finalUrl, config) //eslint-disable-line
			.then(response => response.json().then(json => {
				if (!json.success) {
					if (response.status == 400 || json.error) {
                        return Promise.reject({ code: json.code, error: json.error });
                    }
					return Promise.reject({ code: json.code, error: json.data });
				}

				return Promise.resolve(json);
			}))
			.catch(error => {
				if (window.location.port !== '127.0.0.1') {
					window.Raven.captureException(apiRoot + url, { extra: error });
				}
				return Promise.reject(error)
			});
	}

	joinRootToUrl (url) {
		let finalUrl;
		if (url.includes('newApi')) {
			url = url.substring(6);
			finalUrl = newApiRoot + url;
		} else {
			finalUrl = apiRoot + url;
		}

		return finalUrl;
	}

	formURL (body, url) {
		if (body === null) {
			return url;
		}

		let queryParams = new URLSearchParams();
		if (body.hasOwnProperty('filter')) {
			let filter = body.filter;
			for (let key in filter) {
				queryParams.append('filter[' + key + ']', filter[key])
			}
		}

		if (body.hasOwnProperty('pager')) {
			let pager = body.pager;
			for (let key in pager) {
				queryParams.append('pager[' + key + ']', pager[key])
			}
		}

		url = url + '?' + queryParams.toString();

		return url;
	}
}

export default API;




// WEBPACK FOOTER //
// ./api/index.js